import { Subscription } from 'pages/Join/Join.types';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from 'src/layout/Page';
import './join.css';
import { useTranslation } from 'react-i18next';
import { LoaderProvider } from 'src/hooks/useLoader/LoaderContext';

const Join: React.FC = (): React.ReactElement => {
	const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
	const [language, setLanguage] = useState('he');
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	useEffect(() => {
		setLanguage(i18n.language);
		const getData = async () => {
			const data = await fetch(`${import.meta.env.VITE_API_URL}/subscriptions`, {
				method: 'GET',
			});
			const jsonData = await data.json();
			setSubscriptions(jsonData);
		};

		getData().then();
	}, []);

	useEffect(() => {
		setLanguage(i18n.language);
	}, [i18n.language]);

	const handleSubscribe = (subscription: Subscription) => {
		const queryParams = new URLSearchParams();
		queryParams.set('subscriptionId', subscription.id.toString());
		queryParams.set('isOnline', subscription.isOnline.toString());

		if (i18n.language !== 'en') {
			const url = '/רישום';
			navigate(`${url}?${queryParams.toString()}`);
		} else {
			navigate(`/en/subscribe?${queryParams.toString()}`);
		}
	};

	const getName = (subscription: Subscription): string => {
		if (language === 'he') {
			return subscription.nameHebrew || subscription.name || '';
		}

		return subscription.name || subscription.nameHebrew || '';
	};

	const getDescription = (subscription: Subscription) => {
		if (language === 'he') {
			return subscription.descriptionHebrew || subscription.description || '';
		}

		return subscription.description || subscription.descriptionHebrew || '';
	};

	return <LoaderProvider>
		<Page pageClass={'join-page'}>
			<div className="subscriptions-list">
				{subscriptions.map((subscription) => (
					<div className={'subscription'} key={subscription.id}>
						<div className="subscription-details">
							<div className="subscription-name">
								{getName(subscription) !== ''
									? getName(subscription)
									: `${subscription.lessonsCount} ${t('pages.join.lessonsCount')}`
								}
							</div>
							<div className="subscription-description">
								{getDescription(subscription)}
							</div>
						</div>
						<button
							className={'active continue-subscribe'}
							onClick={() => handleSubscribe(subscription)}
						>
							{t('common.continue')}
						</button>
					</div>
				))}
			</div>
		</Page>
	</LoaderProvider>;
};

export default Join;
